import { InputField } from '../../common/interfaces/InputField';
import { TenderParameters } from '../interfaces/tender-parameters';

export const createValidationFields = (requiredFields: TenderParameters[]): InputField[] => {
  return (
    requiredFields &&
    requiredFields.map((field: TenderParameters, index) => {
      return {
        ...field,
        id: 'manualEntry',
        label: field.name,
        dataTestIdPrefix: field.name.toLowerCase(),
        autoFocus: index === 0,
        helperText: field.validationMessage,
        value: field.value || '',
      };
    })
  );
};

export const addValidationMessage = (
  currentFieldData: TenderParameters[],
  requiredFieldsFromBFF: TenderParameters[],
): TenderParameters[] => {
  return currentFieldData.map(field => {
    requiredFieldsFromBFF.forEach(param => {
      if (param.name === field.name && !!param.validationMessage) {
        field.validationMessage = param.validationMessage;
      }
    });
    return field;
  });
};

export const getRequiredFieldsMessage = (inputFields: TenderParameters[]) => {
  return inputFields.map(inputField => {
    inputField.value === ''
      ? (inputField.validationMessage = `${inputField.name} is required`)
      : (inputField.validationMessage = '');
    return inputField;
  });
};
